import React, { useEffect, useState } from 'react';
import DownChevronIcon from '../../assests/icons/down-chevron.icon';
import DeleteIcon from '../../assests/icons/delete.icon';
import classNames from 'classnames';
import { customMessages } from 'utils';
import * as contactService from 'services/contact.service';

import { message } from 'antd';
import { InfoBox } from 'components';

const SelectGroupList = (props) => {
  const [selected, setSelected] = useState([]);
  const [circles, setCircles] = useState([]);

  const onChange = (e,index) => {
    selected.push(e.id);
    setSelected(selected);
    props.onChange(selected);
  };

  const onRemoveList = (item) => {
    for( var i = 0; i < selected.length; i++){ 
      if ( selected[i] === item.id) { 
          selected.splice(i, 1); 
          break;
      }
    }
    setSelected(selected);
    props.onChange(selected);
  };
   
  function fetchCircle() {
    contactService.getCircles()
      .then((result) => {
        setCircles(result.circle);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  useEffect(() => {
    fetchCircle();
  }, []);

  return (
    <React.Fragment>

    
    <h3>Rehberinizdeki Gruplar</h3>
    <InfoBox
                        type="warning"
                        content={
                          <p>
                           Rehberinizde bulunan gruplardan seçim yapabilirsiniz.
                          </p>
                        }
                      /><br/>
    <div className="message-list--v2">
     
      {circles.map((item, index) => (
        <div
        className={classNames('message-list__item', {'selected':  selected.includes(item.id)})}
          key={'guide-item' + index}
         
        >
          <p>
            {item.name}
            {/* <small>{item.count}</small> */}
          </p>
          <div className="select"  onClick={(e) => (onChange(item, index))}>
            <span>Seç</span>
            <DownChevronIcon />
          </div>
          <div className="delete" onClick={(e)=> onRemoveList(item)}>
            <span>Kaldır</span>
            <DeleteIcon />
          </div>
        </div>
      ))}
    </div></React.Fragment>
  );
};

export default SelectGroupList;
